import React from 'react';
import TouristicSection from './components/TouristicPlaces/TouristicSection';
import { TouristicPlace } from '../../types/types';
import tourCesar from '../../assets/img/touristicPlaces/tour-cesar.jpg';
import souterrains from '../../assets/img/touristicPlaces/souterrains.jpg';
import prieure from '../../assets/img/touristicPlaces/prieure.jpg';
import spectacles from '../../assets/img/touristicPlaces/spectacles.jpg';
import roseraie from '../../assets/img/touristicPlaces/roseraie.jpg';
import donnemarie from '../../assets/img/touristicPlaces/donnemarie.jpg';
import reserve from '../../assets/img/touristicPlaces/reserve.jpg';
import bray from '../../assets/img/touristicPlaces/bray.jpg';

const touristicPlacesProvins: TouristicPlace[] = [
    {
        title: 'Tour César',
        description: 'Monument emblématique de la cité médiévale de Provins.',
        image: tourCesar,
        link: 'https://provins.net/decouvrir-visiter/la-cite-medievale-de-provins/monuments-et-pass-provins/tour-cesar/',
    },
    {
        title: 'Souterrains',
        description: 'Visite guidée de 45 minutes dans les souterrains de Provins.',
        image: souterrains,
        link: 'https://provins.net/decouvrir-visiter/la-cite-medievale-de-provins/monuments-et-pass-provins/souterrains/',
    },
    {
        title: 'Prieuré Saint-Ayoul',
        description: 'Prieuré bénédictin réouvert après 15 ans de rénovation.',
        image: prieure,
        link: 'https://provins.net/decouvrir-visiter/la-cite-medievale-de-provins/evenement-a-provins/',
    },
    {
        title: 'Spectacles',
        description: 'Spectacles équestres et de fauconnerie pour le reste du week-end ou le vendredi après-midi.',
        image: spectacles,
        link: 'https://provins.net/decouvrir-visiter/la-cite-medievale-de-provins/tous-au-spectacle/',
    },
    {
        title: 'Roseraie de Provins',
        description: 'Jardin remarquable connu pour ses 450 variétés de rosiers.',
        image: roseraie,
        link: 'https://provins.net/decouvrir-visiter/la-cite-medievale-de-provins/la-roseraie-de-provins/',
    },
];

const touristicPlacesOther: TouristicPlace[] = [
    {
        title: 'Donnemarie-Dontilly',
        description: 'Jardin médiéval et cloître en accès libre.',
        image: donnemarie,
        link: 'https://provins.net/decouvrir-visiter/destination-le-bassee-montois/village-medieval-de-donnemarie-dontilly-2/',
    },
    {
        title: 'Bray-sur-Seine',
        description: 'Joli village en bord de Seine.',
        image: bray,
        link: 'https://provins.net/decouvrir-visiter/destination-le-bassee-montois/visite-de-bray-sur-seine/',
    },
    {
        title: 'Réserve naturelle de la Bassée',
        description: 'Réserve naturelle nationale au coeur de la Vallée de la Seine.',
        image: reserve,
        link: 'https://provins.net/decouvrir-visiter/destination-le-bassee-montois/la-reserve-naturelle-nationale-de-la-bassee/',
    },
];

const Visit: React.FC = () => {
    return (
        <>
            <TouristicSection
                title="Visiter Provins"
                places={touristicPlacesProvins}
            />

            <TouristicSection
                title="Visiter autour du Domaine"
                places={touristicPlacesOther}
            />
        </>
    );
};

export default Visit;
